import { Paper, Typography } from "@mui/material";
import { Bar } from "react-chartjs-2";

export const OrderGroupedBarChart = ({ data }) => {
    // Group data by day and status
    const days = [...new Set(data.map(item => item.day.trim()))];
    const statuses = [...new Set(data.map(item => item.status))];
  
    const chartData = {
      labels: days,
      datasets: statuses.map(status => ({
        label: status.toUpperCase(),
        data: days.map(day =>
          data
            .filter(item => item.day.trim() === day && item.status === status)
            .reduce((acc, curr) => acc + curr.count, 0)
        ),
        backgroundColor: {
          pending: '#FFC107',
          processing: '#17A2B8',
          received: '#28A745',
          rejected: '#DC3545'
        }[status]
      }))
    };
  
    const options = {
      plugins: {
        legend: { position: 'bottom' }
      },
      scales: {
        x: { stacked: false },
        y: { stacked: false }
      }
    };
  
    return (
      <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>
          Order Status Distribution by Day
        </Typography>
        <Bar data={chartData} options={options} />
      </Paper>
    );
  };